import React from 'react';
import { useAuth } from '@app/Contexts/AuthProvider';
import { useRepository } from '@app/Hooks/useRepository';
import { UserSourcesRepository } from '@api/index';
import type { UserSourceCreateDTO } from '@api/DTO/User/UserSource/dto';
import { UserSourceCreateForm } from './UserSourceCreateForm';
import type { UserSources } from '@api/Entities/User/UserSources';

type UserSourceCreateFormDelegatorProps = {
  userId: number;
  onSave?: (userSource: UserSources) => Promise<void>;
};

export const UserSourceCreateFormDelegator = ({
  onSave,
  userId,
}: UserSourceCreateFormDelegatorProps) => {
  const session = useAuth();
  const userSourceRepository = useRepository(UserSourcesRepository);

  const [isSaving, setIsSaving] = React.useState(false);

  const onSubmit = React.useCallback(
    async (values: UserSourceCreateDTO): Promise<void> => {
      setIsSaving(true);

      try {
        const userSource = await userSourceRepository.addUserSource(userId, values);

        await onSave?.(userSource);
      } finally {
        setIsSaving(false);
      }
    },
    [onSave, userId, userSourceRepository]
  );

  return <UserSourceCreateForm onSubmit={onSubmit} isSaving={isSaving} />;
};
